<div class="dashboard-shell">
  @if (!isSidebarCollapsed() && isSmallScreen()) {
  <div class="dashboard-shell__backdrop" (click)="isSidebarCollapsed.set(true)" aria-hidden="true"></div>
  }
  <zba-sidebar class="dashboard-shell__sidebar" [class.dashboard-shell__sidebar--collapsed]="isSidebarCollapsed()"
    [class.dashboard-shell__sidebar--expanded]="!isSidebarCollapsed()" [collapsed]="isSidebarCollapsed()"
    (collapsedChange)="isSidebarCollapsed.set($event)"></zba-sidebar>
  <div class="dashboard-shell__main">
    <zba-header [sidebarCollapsed]="isSidebarCollapsed()"
      (sidebarCollapsedChange)="isSidebarCollapsed.set($event)"></zba-header>
    <main class="dashboard-shell__content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
<zba-toast></zba-toast>